import { Form, Input, DatePicker, Row, Col } from "antd";
import Modal from "../../../../components/generic/Modal";
import { useEffect, useMemo } from "react";
import dayjs from "../../../../utils/dayjs";
import Select from "../../../../components/generic/Select";
import { PRIORITY_OPTIONS, SUGGESTED_ACTIONS } from "../../../../constant";

const AddReminderModal = ({
  onCancel,
  onAdd,
  isProcessing,
  selectedReminder,
}) => {
  const [form] = Form.useForm();

  const isEdit = useMemo(() => !!selectedReminder?.id, [selectedReminder]);
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        ...selectedReminder,
        due_time: dayjs(selectedReminder?.due_time),
      });
    }
  }, [selectedReminder, isEdit]);

  return (
    <Modal
      title={isEdit ? "Reminder Details" : "Add New Reminder"}
      open
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      isProcessing={isProcessing}
      footer={isEdit ? null : undefined}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onAdd}
        disabled={isEdit || isProcessing}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please enter a title" }]}
        >
          <Input placeholder="Enter reminder title" />
        </Form.Item>

        <Form.Item
          label="Message"
          name="reminder_message"
          rules={[
            { required: true, message: "Please enter a reminder message" },
          ]}
        >
          <Input placeholder="Enter reminder message" />
        </Form.Item>

        <Form.Item
          label="Due Date & Time"
          name="due_time"
          rules={[
            { required: true, message: "Please select a due date and time" },
          ]}
        >
          <DatePicker
            showTime
            style={{ width: "100%" }}
            format="DD-MM-YYYY HH:mm"
            disabledDate={(current) => {
              //@ts-ignore
              return current && current < new Date().setHours(0, 0, 0, 0);
            }}
          />
        </Form.Item>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Priority"
              name="priority"
              rules={[{ required: true, message: "Please select priority" }]}
            >
              <Select
                placeholder="Select priority"
                options={PRIORITY_OPTIONS}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Suggested Action"
              name="suggested_action"
              rules={[
                { required: true, message: "Please select a suggested action" },
              ]}
            >
              <Select
                placeholder="Select suggested action"
                options={SUGGESTED_ACTIONS}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please enter a description" }]}
        >
          <Input.TextArea rows={4} placeholder="Enter reminder description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddReminderModal;
